// 1. IMPORTS
import React from "react";
import { Form, notification, Upload } from "antd";
import { CopyOutlined } from "@ant-design/icons";
import CopyToClipboard from "react-copy-to-clipboard";
import uploadService from "services/uploadService";
import { validateUploadedFiles } from "helper/UtilsFunctionsValidation";

// 2. COMPONENT
function PaymentMethodQrCodeField({ required = false }) {
  // 4. EVENT HANDLERS
  const handleUpload = ({ file, onSuccess, onError }) => {
    const reader = new FileReader();
    reader.onerror = () => onError(new Error("Không đọc được ảnh QR Code"));
    reader.onload = async () => {
      try {
        const response = await uploadService.uploadImage({
          imageData: reader.result.replace(`data:${file.type};base64,`, ""),
          imageFormat: file.name.split(".").pop().toLowerCase(),
        });
        if (!response.issSuccess) throw new Error("Upload thất bại");
        file.url = response.data;
        onSuccess({ url: response.data });
      } catch (error) {
        onError(error);
      }
    };
    reader.readAsDataURL(file);
  };

  // 6. FORM CONFIGURATION
  const rules = [
    { required, message: "Vui lòng chọn ảnh QR Code" },
    { validator: validateUploadedFiles },
  ];

  // 8. MAIN JSX
  return (
    <>
      <Form.Item
        label="Ảnh QR Code"
        name="paymentMethodQrCodeUrl"
        rules={rules}
        valuePropName="fileList"
        getValueFromEvent={(event) => Array.isArray(event) ? event : event?.fileList || []}
      >
        <Upload
          name="file"
          listType="picture-card"
          accept="image/*"
          maxCount={1}
          showUploadList
          customRequest={handleUpload}
        >
          + Tải ảnh
        </Upload>
      </Form.Item>
      <Form.Item noStyle shouldUpdate>
        {({ getFieldValue }) => {
          const url = getFieldValue("paymentMethodQrCodeUrl")?.[0]?.url;
          return url ? (
            <p className="mb-3" style={{ marginTop: -20 }}>
              Link ảnh QR Code:{" "}
              <CopyToClipboard
                text={url}
                onCopy={() => notification.success({ message: "Sao chép thành công" })}
              >
                <CopyOutlined height={20} width={20} className="ml-1" />
              </CopyToClipboard>{" "}
              <a href={url} target="_blank" rel="noopener noreferrer" style={{ wordBreak: "break-all" }}>
                {url}
              </a>
            </p>
          ) : null;
        }}
      </Form.Item>
    </>
  );
}

// 9. EXPORTS
export default PaymentMethodQrCodeField;